/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { GalaxyParent } from 'solis/rpc/parent';


export const createGalaxyRoutes = (routes) =>
{
  routes.createDetach('galaxy', (application) =>
  {
    application.unloadGalaxy()
  });

  routes.createRecord('currentTime', {
    load:   (application, cass) => application.loadCurrentTime(cass),
    unload: (application)       => application.unloadCurrentTime(),
  });

  routes.createRecord('settings', {
    load:   (application, cass) => application.loadSettings(cass),
    unload: (application)       => application.unloadSettings(),
  });

  routes.createRecord('galaxy/cass', {
    load:   (application, cass) => application.loadGalaxy(cass),
    unload: (application)       => application.unloadGalaxy(),
  });

  routes.createRecord('galaxy/currentUser', {
    parent: GalaxyParent,
    load:   (galaxy, cass) => galaxy.loadCurrentAccount(cass.id),
    unload: (galaxy)       => galaxy.unloadCurrentAccount(),
  });

  routes.createTable('galaxy/scores', {
    parent: GalaxyParent,
    load:   (galaxy, cass) => galaxy.loadScore(cass),
    unload: (galaxy, cass) => galaxy.unloadScore(cass),
    values: (galaxy) => galaxy.getScores().values(),
  });
};
